import useQueryState from '@discover-use-query-state';
import DEFAULT_HAS_LAST_TABLE from '@discover-data/stores/restaurant/model/hasLastTable/default';
import getValidHasLastTable from './getValid';

export default function useHasLastTableQueryState() {
  return useQueryState('has-last-table', getValidHasLastTable, DEFAULT_HAS_LAST_TABLE);
}
